// frontend/src/utils/textUtils.js

/**
 * Truncate text to specified number of words
 * @param {string} text - The text to truncate
 * @param {number} wordLimit - Maximum number of words (default: 50)
 * @returns {string} Truncated text with ellipsis if needed
 */
export const truncateWords = (text, wordLimit = 50) => {
  if (!text) return '';

  const words = text.trim().split(/\s+/);

  if (words.length <= wordLimit) {
    return text;
  }

  return words.slice(0, wordLimit).join(' ') + '...';
};

/**
 * Truncate text to specified number of characters
 * @param {string} text - The text to truncate
 * @param {number} charLimit - Maximum number of characters
 * @returns {string} Truncated text with ellipsis if needed
 */
export const truncateChars = (text, charLimit = 100) => {
  if (!text) return '';

  if (text.length <= charLimit) {
    return text;
  }

  return text.substring(0, charLimit) + '...';
};

/**
 * Canonicalise an email address the same way the backend's `normalize_email`
 * does (trim + lowercase) so the value we DISPLAY and the value we SEND always
 * match the value stored on `users.email`.
 *
 * WHY: registration stores the normalized address, but the Register page used
 * to hand the raw typed string to /verify-email and /resend-verification, so
 * "Asaf@gmail.com" never matched the stored "asaf@gmail.com" - the code was
 * rejected and the resend silently sent nothing. The server is authoritative;
 * this is the client-side belt-and-braces half.
 *
 * Null-safe on purpose: callers pass router state / query params, either of
 * which can be absent.
 *
 * @param {string} value - Raw email address as typed or as received in a URL.
 * @returns {string} Trimmed, lowercased address ('' when there is no value).
 */
export const normalizeEmail = (value) => String(value ?? '').trim().toLowerCase();
